import billing_theme from "style/theme_colors";
import styled from "styled-components";

export const NewKitContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 40px;
  background: ${billing_theme.pallete.specific.T_50_25};
  width: 93%;
  margin: 0 auto;
  padding: 24px 24px;
  border-radius: 12px;
  -webkit-box-shadow: 0px 0px 24px 1px rgba(190, 190, 190, 0.3803921569);
  -moz-box-shadow: 0px 0px 24px 1px rgba(190, 190, 190, 0.3803921569);
  box-shadow: 2px 4px 4px 0px ${billing_theme.pallete.box_shadow};
  margin-top: 16px;
  margin-bottom: 16px;

  .descri {
    width: 100%;
  }
`;
export const NewKitInfo = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-template-rows: repeat(1, 1fr);

  gap: 24px;
`;

export const NewKitTwoInputs = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(1, 1fr);

  gap: 24px;
`;

export const NewKitValores = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-template-rows: repeat(1, 1fr);

  gap: 24px;
`;
export const NewKitDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;
export const NewKitButton = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  gap: 12px;
`;
